import Vue from 'vue'
import Router from 'vue-router'
import NotFound from './views/NotFound.vue'
import Preview from './views/Preview.vue'
import Tutorial from './views/Tutorial.vue'
import Home from './views/Home.vue'
import Flavors from './views/Flavors.vue'
import Content from './views/Content.vue'
import Cart from './views/Cart.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'home' }
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: NotFound
    },
    {
      path: '/preview',
      name: 'preview',
      component: Preview
    },
    {
      path: '*',
      redirect: { name: 'not-found' }
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/flavors',
      name: 'flavors',
      component: Flavors
    },
    {
      path: '/content/:uid',
      name: 'content',
      component: Content
    },
    {
      path: '/cart',
      name: 'cart',
      component: Cart
    }
  ]
})
